export default __webpack_public_path__ + "cancel-login.a35f34f2.png";